/**
 * Copyright © Magento, Inc. All rights reserved.
 * See COPYING.txt for license details.
 */

define('Magento_Shipping/js/model/config',[], function () {
    'use strict';

    return function () {
        return window.checkoutConfig.shippingPolicy;
    };
});

